export class ViewUserAdminModel{
    Ad_User_PkeyID:number=0;
    Ad_User_First_Name:string='';
    Ad_User_Last_Name:string='';
    Ad_User_Address:string='';
    Ad_User_City:string='';
    Ad_User_State:string='';
    Ad_User_Mobile:string='';
    Ad_User_Login_Name:string='';
    Ad_User_Password:string='';
    Ad_User_UserVal:string='';
    Ad_User_Email:string='';
    Ad_User_Type:number=0;
    Ad_User_IsActive:boolean=true;
    Ad_User_IsDelete:boolean=false;
    UserID: Number = 0;
    Type:number=1; 
    MUR_Role:number = 0
  tokendetails: any;
}